module.exports = __webpack_public_path__ + "static/img/modulo_bluetooth_hc_05-2.02f8a7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/modulo_bluetooth_hc_05-2.svg
// module id = zMyT
// module chunks = 0